import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ActBtn from 'components/buttons/ActBtn'
import PropTypes from 'prop-types'
import Alert from 'react-bootstrap/Alert'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { useHistory } from 'react-router-dom'
import { klass } from 'utils'
import './styles.scss'

//generates a warning as ActBtn tries to change while it's being removed... no biggie?
/**
 * @param show {boolean=true} Also won't render if there's no children elements.
 * @param icon {string|string[]}
 * @param flip
 * @param action {string|function} Either a function to trigger when the button is pressed, or an internal/external link
 * @param actionExternal {boolean} If true, the action is considered an external URL
 * @param actionFull {boolean} If true, the action also gets triggered in the whole text section of the alert. Goes well with btnHideSm if the text has a CTA, but this may hinder usability - specially if you try to add a help tooltip on the banner!
 * @param variant
 * @param btnTxt
 * @param btnVariant
 * @param btnHideSm {boolean} Hides the button if the screen size is XS or SM - goes well with actionFull if the text has a CTA
 * @param long {boolean}
 * @param className {string}
 * @returns {null|JSX.Element}
 */
export function FixedWarning({ show = true, icon = 'exclamation-triangle', flip, action = null, actionExternal = false, actionFull = false, btnTxt = null, btnVariant = null, btnHideSm = false, variant = 'danger', long = false, className = '', ...props }) {
	const history = useHistory()
	if (typeof action == 'string') {
		const url = action
		action    = actionExternal?
			() => window.open(url, '_blank', 'noopener noreferrer') :
			() => history.push(url)
	}

	return !show || !props.children? null : (
		<Alert variant={variant} {...klass('alert-fixed', className)} {...props}>
			<Row className="justify-content-sm-center">
				<Col xs sm={long? false : 'auto'} xl="auto" {...klass('pr-0 pr-sm-3 content', { textCenterSm: long })} onClick={actionFull? action : null}>
					<FontAwesomeIcon flip={flip} icon={icon} size="lg"/> {props.children}
				</Col>
				{btnTxt && <Col xs="auto" className={btnHideSm? "d-none d-md-block d-lg-block d-xl-block" : ''}>
					<ActBtn texts={[btnTxt, '']} variant={btnVariant || variant} action={action} size="sm"/>
				</Col>}
			</Row>
		</Alert>
	)
}

FixedWarning.propTypes = {
	variant       : PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light']),
	show          : PropTypes.bool,
	icon          : PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
	flip          : PropTypes.oneOf(['horizontal','vertical','both']),
	btnTxt        : PropTypes.string,
	btnVariant    : PropTypes.string,
	btnHideSm     : PropTypes.bool,
	action        : PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
	actionExternal: PropTypes.bool,
	long          : PropTypes.bool,
	className     : PropTypes.string,
}
